export default __webpack_public_path__ + "static/media/box_check_white.a47a3bb0.svg";